<template>
  <section class="container">
    <div class="card-wrap mt-20 mb-20">
      <el-tabs>
        <el-row :gutter="24">
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <span>名片信息</span>
              <el-form
                ref="qrForm"
                class="add-form"
                label-width="100px"
                label-position="left"
                :rules="rules"
                :model="cardInfo"
                style="margin-top: 3%"
              >
                <div class="add-form-item">
                  <el-form-item label="姓名：" prop="cardName">
                    <el-input
                      v-model="cardInfo.cardName"
                      maxlength="130"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div
                  style="    margin-top: -3%;
    margin-left: 15%;"
                >
                  <span class="validate ml-20"> * 最多输入130个字符</span>
                </div>
                <div class="add-form-item">
                  <el-form-item label="职位：" prop="cardPost">
                    <el-input
                      v-model="cardInfo.cardPost"
                      maxlength="130"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div
                  style="    margin-top: -3%;
    margin-left: 15%;"
                >
                  <span class="validate ml-20"> * 最多输入130个字符</span>
                </div>
                <div class="add-form-item">
                  <el-form-item label="手机：" prop="cardMobile">
                    <el-input
                      v-model="cardInfo.cardMobile"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="座机：" prop="landlineNumber">
                    <el-input
                      v-model="cardInfo.cardQuhao"
                      maxlength="4"
                      style="width: 20%"
                    />-
                    <el-input v-model="cardInfo.cardPhone" style="width: 40%" />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="邮箱：" prop="cardEmail">
                    <el-input
                      v-model="cardInfo.cardEmail"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="地址：" prop="cardAddress">
                    <el-input
                      v-model="cardInfo.cardAddress"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="网址：" prop="cardUrl">
                    <el-input
                      v-model="cardInfo.cardUrl"
                      placeholder="http://m.haier.com"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="备注：" prop="cardRemark">
                    <el-input
                      v-model="cardInfo.cardRemark"
                      type="textarea"
                      style="width: 135%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item>
                    <el-button type="primary" @click="saveMarketing"
                      >生成二维码</el-button
                    >
                    <el-button type="primary" @click="downloadQrcode"
                      >下载二维码</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-col>
          <div
            style="float:left;width: 1px;height: 700px; background: #d4d4d4;"
          ></div>
          <div>
            <QrCodeInfo
              ref="qrCodeInfo"
              @getCardList="getCardList"
              :dataInfo="dataInfo"
            />
          </div>
        </el-row>
      </el-tabs>
    </div>
    <br />
    <div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.cardName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="职位" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.cardPost }}</span>
          </template>
        </el-table-column>
        <el-table-column label="座机" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.cardQuhao }}-{{ scope.row.cardPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.cardMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="邮箱" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.cardEmail }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="showCard(scope.row)" type="editCard"
              >查看</el-button
            >
            <el-button size="mini" type="danger" @click="deleteCard(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import QrCodeInfo from "./webQrCodeInfo.vue";

export default {
  components: { QrCodeInfo },
  data() {
    return {
      cardInfo: {
        cardId: "",
        cardName: "",
        cardPost: "",
        cardQuhao: "",
        cardPhone: "",
        cardMobile: "",
        cardEmail: "",
        cardAddress: "",
        cardUrl: "",
        cardRemark: "",
        jingioid: ""
      },
      rules: {
        cardName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            max: 130,
            message: "最多输入130个字符",
            trigger: "change"
          }
        ],
        cardPost: [
          {
            required: true,
            message: "请输入职位",
            trigger: "blur"
          },
          {
            max: 130,
            message: "最多输入130个字符",
            trigger: "change"
          }
        ],
        cardMobile: [
          {
            required: true,
            message: "请输入手机",
            trigger: "blur"
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机格式"
          },
          {
            min: 0,
            max: 11,
            message: "长度不能多于 11 个字符",
            trigger: "blur"
          }
        ]
      },
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dataInfo: {}
    };
  },
  methods: {
    //生成二维码
    saveMarketing() {
      let _this = this;
      if (
        _this.cardInfo.cardEmail !== "" &&
        _this.cardInfo.cardEmail !== null &&
        _this.cardInfo.cardEmail !== undefined
      ) {
        let emailReg = /^([a-zA-Z0-9]*[-_.]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]*[-_]?[a-zA-Z0-9]+)+[\\\\.][A-Za-z]{2,3}([\\\\.][A-Za-z]{2})?$/;
        if (!emailReg.test(_this.cardInfo.cardEmail)) {
          _this.$message.error("请输入正确的邮箱格式!");
        }
      }
      _this.$refs.qrForm.validate(isPass => {
        if (isPass) {
          _this.$refs.qrCodeInfo.createCode(_this.cardInfo, 2);
        }
      });
    },
    //下载二维码
    downloadQrcode() {
      let _this = this;
      _this.$refs.qrCodeInfo.downloadQrcode();
    },
    getCardList() {
      let _this = this;
      let param = {
        url: "/api/card/getCarPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getCardList", param).then(() => {
        _this.list = _this.$store.state.newQrCode.cardList.list;
        _this.total = _this.$store.state.newQrCode.cardList.total;
      });
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getCardList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getCardList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getCardList();
    },
    //编辑
    showCard(info) {
      let _this = this;
      _this.cardInfo.cardName = info.cardName;
      _this.cardInfo.cardPost = info.cardPost;
      _this.cardInfo.cardQuhao = info.cardQuhao;
      _this.cardInfo.cardPhone = info.cardPhone;
      _this.cardInfo.cardMobile = info.cardMobile;
      _this.cardInfo.cardEmail = info.cardEmail;
      _this.cardInfo.cardAddress = info.cardAddress;
      _this.cardInfo.cardUrl = info.cardUrl;
      _this.cardInfo.cardRemark = info.cardRemark;
      _this.cardInfo.jingioid = info.jingioid;
      _this.dataInfo = {
        data: info.jingioid,
        logoSrc: info.logo,
        size: info.size,
        foreColor: info.foreColor,
        backColor: info.backColor,
        formWork: info.formWork,
        faultToleRance: info.faultToleRance
      };
    },
    //删除
    deleteCard: function(row) {
      let _this = this;
      _this
        .$confirm("确定要删除该条名片二维码吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let param = {
            url: "/api/card/deleteCardById",
            params: { cardId: row.cardId }
          };

          _this.$Api
            .get(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.getCardList();
                _this.$message({
                  message: "文本二维码删除成功",
                  type: "success"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        });
    }
  },
  created() {
    let _this = this;
    _this.getCardList();
  }
};
</script>

<style lang="sass" scoped>
  .add-form-item
    display: flex
    .el-form
      border-right: 1px solid #b6b6b6
      padding-right: 200px
      .el-form-item__content
        width: 129%
.pagination
    text-align: center
.validate
  height: 40px
  line-height: 40px
  font-size: 10px
  color: #E6A23C
</style>
